import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'back-link',
  templateUrl: './back-link.component.html'
})
export class BackLinkComponent implements OnInit {

  constructor(
    public location: Location
    ){
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/components/partials/back-link/back-link.component.ts